import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React, { useEffect, useRef, useState } from 'react';
import * as XLSX from 'xlsx';
// import * as XLSX from 'sheetjs-style';
import { generatePdf } from './utils/commonFunctions';
import { Button } from 'react-bootstrap';
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from 'react-icons/md';

const ShowReport = ({ dataSet }) => {

  const [sortedColumn, setSortedColumn] = useState(-1); const [sortOrder, setSortOrder] = useState('asc'); const tableRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { data, headings = [], headings1 = [], headings2 = [], links, aligns, totals, datatypes, displays, pdfwidths, tablehead, reportgeneratedtime, pagination, search, pdfdownload, exceldownload } = dataSet ?? {};
  const totalItems = data ? data.length : 0;
  const [itemsPerPage, setItemsPerPage] = useState(10);const totalPages = pagination && pagination === 'true' ? Math.ceil(totalItems / itemsPerPage) : 1;
  

  useEffect(() => { setCurrentPage(1); }, [dataSet]);

  const handlePageChange = (newPage) => { setCurrentPage(newPage); };

  const startIndex = (currentPage - 1) * itemsPerPage; const endIndex = startIndex + parseInt(itemsPerPage);
  const slicedData = pagination && pagination === 'true' ? data ? data.slice(startIndex, endIndex) : [] : data;
  const [searchInput, setSearchInput] = useState(''); const [showFilteredData, setShowFilteredData] = useState(false);
  const searchTable = (inputValue) => {
    if (inputValue === '') { setShowFilteredData(false) }
    else { setSearchInput(inputValue.toUpperCase()); setShowFilteredData(true); }
  };

  const filteredData = data ? data.filter((row) => row.some( (cell) => typeof cell === 'string' && cell.toUpperCase().includes(searchInput) ) ) : [];


  const getFormattedTimestamp = () => { return new Date()
      .toLocaleString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      })
      .replace(/[^\d]/g, '');
  };



  const handleExportCSV = () => {
    const headersTable = document.createElement('table'); headersTable.innerHTML = tableRef.current.querySelector('thead').outerHTML;
    const ws = XLSX.utils.table_to_sheet(headersTable);
    const dataRows = data.map((row, rowIndex) => [rowIndex + 1, ...row]);
    XLSX.utils.sheet_add_aoa(ws, dataRows, { origin: -1 }); 
    const footers = Array.from(tableRef.current.querySelectorAll('tfoot tr')).map((row) => Array.from(row.children).map((cell) => cell.textContent) );
    XLSX.utils.sheet_add_aoa(ws, footers, { origin: -1 }); // Append footers to the end of the sheet
  
    const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws); const timestamp = getFormattedTimestamp();
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    // link.download = excelFileName;
    link.click();
  };


  let a = "left";
  let o = 0;
  const td_color = null;
  const colour = null;
  const tableFoot = null;
  const total_links = null;


  const amountWords = null;
 
  let cols = 0;
 
 
  const handleEntriesPerPageChange = (value) => {
    setCurrentPage(1); setShowFilteredData(false); setItemsPerPage(value === 'All' ? totalItems : value);

  };

  const sortTable = (columnIndex) => {
    const table = document.getElementById('DataTable'); // Assuming your table ID is 'DataTable'
    const tbody = table.querySelector('tbody'); const rows = Array.from(tbody.getElementsByTagName('tr')); const isAscending = columnIndex === sortedColumn && sortOrder === 'asc';

    rows.sort((rowA, rowB) => {
      const cellA = rowA.getElementsByTagName('td')[columnIndex]; const cellB = rowB.getElementsByTagName('td')[columnIndex];
const valueA = cellA ? cellA.textContent.trim() : ''; const valueB = cellB ? cellB.textContent.trim() : '';

      if (isAscending) {
        return valueA.localeCompare(valueB, undefined, { numeric: true, sensitivity: 'base' });
      } else {
        return valueB.localeCompare(valueA, undefined, { numeric: true, sensitivity: 'base' });
      }
    });

    // Clear existing rows from the tbody
    tbody.innerHTML = '';

    // Append the sorted rows back to the tbody
    rows.forEach((sortedRow) => tbody.appendChild(sortedRow));

    // Update state to reflect the current sorted column and order
    setSortedColumn(columnIndex);
    setSortOrder(isAscending ? 'desc' : 'asc');
  };



  const paginationControls = () => {
    const pages = Array.from({ length: totalPages }, (_, index) => index + 1);
 
    return (
      <nav aria-label="Page navigation" >
        <div className="pagination-container ">
          <ul className="pagination">
          <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <a className="page-link" href="#" aria-label="Next" onClick={(e) => {
                e.preventDefault();
                handlePageChange(currentPage + 1);
              }}>
                <span aria-hidden="true">Next</span>
              </a>
            </li>
            {/* {pages.map((page) => (
              <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
                <a className="page-link" onClick={() => handlePageChange(page)}>
                  {page}
                </a>
              </li>
            ))} */}
             {/* Last Page (First in order) */}
      {/* {pages[pages.length - 1] !== totalPages && (
        <>
          <li className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => {
              e.preventDefault();
              handlePageChange(totalPages);
            }}>{totalPages}</a>
          </li>
          {pages[pages.length - 1] < totalPages - 1 && <li className="page-item disabled"><span className="page-link">...</span></li>}
        </>
      )} */}

      {/* Reverse Page Numbers */}
      {[...pages].reverse().map((page) => (
        <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
          <a className="page-link" href="#" onClick={(e) => {
            e.preventDefault();
            handlePageChange(page);
          }}>
            {page}
          </a>
        </li>
      ))}

      {/* First Page (Last in order) */}
      {/* {pages[0] !== 1 && (
        <>
          {pages[0] > 2 && <li className="page-item disabled"><span className="page-link">...</span></li>}
          <li className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
            <a className="page-link" href="#" onClick={(e) => {
              e.preventDefault();
              handlePageChange(1);
            }}>1</a>
          </li>
        </>
      )} */}
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <a className="page-link" href="#" aria-label="Previous" onClick={(e) => {
                e.preventDefault();
                handlePageChange(currentPage - 1);
              }}>
                <span aria-hidden="true">Previous</span>
              </a>
            </li>
           
          </ul>
        </div>
      </nav>
    )

  }

  const showEntries = () => {


    return (

      <div className="entries-per-page">
        <span style={{ marginRight: '5px', fontSize:"20px", fontFamily: "Roboto Condensed, sans-serif"}}>Show</span>
        <select
          id="entriesPerPage"
          className="form-select d-inline-block"
          style={{ width: '75px', marginRight: '5px' }} // Adjust the width as needed
          onChange={(e) => handleEntriesPerPageChange(e.target.value)}
          value={itemsPerPage === totalItems ? 'All' : parseInt(itemsPerPage, 10)}
        >
          {[10, 25, 50, 100, 'All'].map((entries) => (
            <option key={entries} value={entries}>
              {entries}
            </option>
          ))}
        </select>
        <span style={{fontSize:"20px",fontFamily: "Roboto Condensed, sans-serif"}}>Entries</span>
      </div>



    );
  };




  return (
    <>

      {/* {data && data.length > 0 ? ( */}
        <span>

          <div className="row" style={{ marginTop: '-25px', marginBottom: '3px' }}>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3 className="popuptitle" id="tablehead" style={{}}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i> 
                {/* {tablehead} */}
              </h3>
            </div>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '5px',
            marginBottom: '-25px'
          }} >
            <div style={{ flex: 1 }}> {pagination && pagination === 'true' && showEntries()}  </div>
            <div syle={{ flex: 1 }}>

          
            {exceldownload && exceldownload === 'true' && <Button  variant="success"  size="sm"   className="btn mx-2 mt-2 mb-1 excel-btn"  style={{  color: "#ffffff", marginLeft: "3px" }} onClick={handleExportCSV} > Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </Button> }
              {pdfdownload && pdfdownload === 'true' && <Button variant="danger" size="sm" className="btn mx-2 mt-2 mb-1 pdf-btn"  style={{  marginLeft: "3px"}} onClick={()=>{generatePdf("#DataTable","QueryExplorer.pdf")}}> PDF <MdOutlinePictureAsPdf /> </Button> }
             
              
             
            </div>
            
              {search && search === 'true' && 
              <div style={{ flex: 1, marginLeft: '40px', display: "flex", alignItems: "center", border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "50px", minWidth: "50px", }}
                                onFocus={(e) => { e.currentTarget.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; e.currentTarget.style.border = "1px solid #353935"; e.currentTarget.style.width = "100%"; }}
                                onBlur={(e) => { e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; e.currentTarget.style.border = "1px solid #ddd"; e.currentTarget.style.width = "150px"; }}
                              >
                                <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible", }} />
                                <input type="text" placeholder="Search " 
                                // value={searchText1}
                                  onKeyUp={(e) => searchTable(e.target.value)}
                                  style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0", }} />
                              </div>
             
              }
           
          </div>
          <div id="DataTableRawDiv" className="table-responsive mt-5 mb-5">

            <table ref={tableRef} align="center" border="1" className="table table-bordered custom-table table-responsive " id="DataTable" >
              <thead>
              {headings1 && headings1.length>0 && (
  <tr>
    {headings1.map((head, index) => {
      const headCol1 = head.split('#');
 
      return (
        <th
          key={index}
          style={{
            textAlign: 'center',
            backgroundColor: 'red',
          }}
          colSpan={headCol1[0]}
          rowSpan={headCol1[1]}
        >
          {headCol1[2]}
        </th>
      );
    })}
  </tr>
)}
 
 {headings2 && headings2.length>0&& (
  <tr>
    {headings2.map((head, index) => {
      const headCol2 = head.split('#');
 
      return (
        <th key={index} style={{ textAlign: 'center', backgroundColor: 'red', }} colSpan={headCol2[0]} rowSpan={headCol2[1]} > {headCol2[2]} </th>
      );
    })}
  </tr>
)}
 

                <tr>
                  {headings && headings.map((item, index) => ( <th key={index} align="center"> {item} </th> ))}
                </tr>

                <tr>
                  {displays && displays.map((value, index) => {
                    if (value === "Y") {
                      o++;

                      return (
                        <th key={index} align="center">

<a role="button" tabIndex="0" onClick={() => sortTable(index)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") sortTable(index); }} title="Click to sort" style={{ fontSize: '15px', color: '#FFF', cursor: 'pointer' }} aria-label={`Sort column ${o}`} > <i className="fa fa-sort" aria-hidden="true"></i> </a>
                          {/* <a data-toggle="tooltip" onClick={() => sortTable(index)} title="Click to sort" style={{ fontSize: '15px', color: '#FFF', cursor: 'pointer' }}> <i className="fa fa-sort" aria-hidden="true"></i> </a>
                          {o}
                          <a data-toggle="tooltip" onClick={() => sortTable(index)} title="Click to sort" style={{ fontSize: '15px', color: '#FFF', cursor: 'pointer' }}> <i className="fa fa-sort" aria-hidden="true"></i> </a> */}
                        </th>
                      );
                    }

                    return null; // Render nothing if value is not "Y"
                  })}
                </tr>
              </thead>

              <tbody>
                {data && !showFilteredData && slicedData.map((row, rowIndex) => {


                  return (
                    <tr key={rowIndex}>
                      <td align="center">{rowIndex + 1}</td>
                      {row.map((cell, colIndex) => {
                        if (displays[colIndex + 1] === "Y") {
                          if (aligns[colIndex + 1] === "C") { a = "center"; } 
                          else if (aligns[colIndex + 1] === "R") { a = "right"; } 
                          else { a = "left"; }

                          let color = "";
                          if (td_color !== null) {
                            color = colour[colIndex + 1];
                          }
                          cols = (colIndex + 1) + 1;
                          return (
                            <td key={colIndex} style={{ color: color }} align={a} > {links[colIndex + 1] === "N" ? ( <div dangerouslySetInnerHTML={{ __html: cell }} /> ) : ( <> {(() => { const l = parseInt(links[colIndex + 1].substring(0, 1)); return ( <a style={{ color: `#fb641b,font-weight:500!, ${color}`, }} data-toggle="tooltip" title="Click here to get Detailed Reports" href={`${links[colIndex + 1].substring(1)}${row[l - 1]}`} > <span style={{ fontSize: '22px' }}>{cell}</span> </a> ); })()} </> )} </td>
                          );
                        }

                        return null;
                      })}

                    </tr>
                  );
                })}
                {
                  data && showFilteredData && filteredData.map((row, rowIndex) => {


                    return (
                      <tr key={rowIndex}>
                        <td align="center">{rowIndex + 1}</td>
                        {row.map((cell, colIndex) => {
                          if (displays[colIndex + 1] === "Y") {
                            if (aligns[colIndex + 1] === "C") {
                              a = "center";
                            } else if (aligns[colIndex + 1] === "R") {
                              a = "right";
                            } else {
                              a = "left";
                            }

                            let color = "";
                            if (td_color !== null) {
                              color = colour[colIndex + 1];
                            }
                            cols = (colIndex + 1) + 1;
                            return (
                              <td
                                key={colIndex}
                                style={{ color: color }}
                                align={a}
                              >
                                {links[colIndex + 1] === "N" ? (
                                   <div dangerouslySetInnerHTML={{ __html: cell }} />
                                ) : (
                                  <>
                                    {(() => {
                                      const l = parseInt(links[colIndex + 1].substring(0, 1));
                                      return (
                                        <a
                                          style={{ color: `#fb641b,font-weight:500!, ${color}`, }}
                                          data-toggle="tooltip"
                                          title="Click here to get Detailed Reports"
                                          href={`${links[colIndex + 1].substring(1)}${row[l - 1]}`}
                                        >
                                          <span style={{ fontSize: '22px' }}>{cell}</span>
                                        </a>
                                      );
                                    })()}
                                  </>
                                )}
                              </td>
                            );
                          }

                          return null;
                        })}

                      </tr>
                    );
                  })}

              </tbody>

              <tfoot>
              {data && !showFilteredData &&
                <tr>

                  <td style={{ fontSize: 'small' }} colSpan="1">
                    Totals
                  </td>
                  {data && !showFilteredData &&
                    totals.map((totalType, j) => {
                      if (j > 0 && displays[j] === 'Y') {
                        if (totalType === 'T') {
                          if (datatypes[j] === 'I') {
                            let t = 0;
                            for (let i = 0; i < data.length; i++) {
                              const row = data[i];
                              t += parseInt(row[j - 1]);
                            }
                            return (
                              <td key={j} align="right">
                                {total_links === 'Y' && links[j] !== 'N' ? (
                                  <a style={{ color: 'orange' }} href={`${links[j].substring(1)}total`}> <span style={{ fontSize: 'small' }}>{t}</span> </a>
                                ) : (
                                  <>
                                    {(() => {
                                      const l = parseInt(links[j].substring(0, 1));
                                      return (
                                        <span id="TOTALS" data-toggle="tooltip" title={amountWords} style={{ fontSize: '20px', cursor: 'pointer' }} > {t} </span>
                                      );
                                    })()}
                                  </>
                                )}
                              </td>
                            );
                          } else if (datatypes[j] === 'D') {
                            let t = 0;
                            for (let i = 0; i < data.length; i++) {
                              const row = data[i];
                              t += parseFloat(row[j - 1]);
                            }
                            return (
                              <td key={j} align="right">
                                {total_links === 'Y' && links[j] !== 'N' ? (
                                  <a style={{ color: 'orange' }} href={`${links[j].substring(1)}total`}>
                                    <span style={{ fontSize: 'small' }}>{t}</span>
                                  </a>
                                ) : (
                                  <td align="right">{t}</td>
                                )}
                              </td>
                            );
                          }
                        } 
                        else if (totalType === 'C') { return <td key={j} className="textBold12" align="right">{data.length}</td>; } 
                        else { return <td key={j} className="textnormal12"></td>; }
                      }
                      return null;
                    })}
                </tr>
}
                {tableFoot && !showFilteredData (
                  <tr>
                    <td colSpan={cols}>
                      {/* {CONTEXT_NAME}  */}
                      if  Report Generated Date and Time:
                      {reportgeneratedtime}
                      <br />
                      {tableFoot}
                    </td>
                  </tr>
                )}
                {!tableFoot && data && !showFilteredData  && (
                  <tr>
                    <td colSpan={cols}>
                      {/* {CONTEXT_NAME}  */}
                      Report Generated Date and Time: &nbsp;&nbsp;
                      {reportgeneratedtime}
                    </td>
                  </tr>
                )}
              </tfoot>

            </table></div>

<div className="mb-5"
style={{
            display: 'flex',
            justifyContent: 'space-between',

          }} >
            <div style={{ flex: 1 }}>   </div>
            <div style={{ marginLeft: '10px', marginTop: '-20px' }}> { pagination && pagination === 'true' && paginationControls() } </div>
          </div>
        </span>
      {/* )  : */}
        {/* (<div className={'failure'} style={{ textAlign: 'center' }}>
          <strong> No Data Found</strong>
        </div>)} */}

    </>
  )
}

export default ShowReport